import CreateClientPage from "@/views/CreateClientPage.vue";
import CreateQuotePage from "@/views/CreateQuotePage.vue";
import LoginPage from "@/views/LoginPage.vue";
import QuotePage from "@/views/QuotePage.vue";
import StockPage from "@/views/StockPage.vue";
import { createRouter, createWebHistory } from "vue-router";
import NotFound from "../components/notFound.vue";
import AccountPage from "../views/AccountPage.vue";
import ClientPage from "../views/ClientPage.vue";
import CreateItemPage from "../views/CreateItemPage.vue";
import CreateOperatorPage from "../views/CreateOperatorPage.vue";
import EditClientPage from "../views/EditClientPage.vue";
import EditItemPage from "../views/EditItemPage.vue";
import EditOperatorPage from "../views/EditOperatorPage.vue";
import EditQuotePage from "../views/EditQuotePage.vue";
import HomePage from "../views/HomePage.vue";
import OperatorPage from "../views/OperatorPage.vue";
import OperatorQuotePage from "../views/OperatorQuotePage.vue";
import SendEmailPage from "../views/SendEmailPage.vue";
import SetNewPasswordPage from "../views/SetNewPasswordPage.vue";
import { globalBeforeEachGuard } from "./routeGuards";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    meta: {
      hideAccountLink: true,
      showLogo: true,
      hideButton: true,
      hideDropdown: true,
    },
    children: [
      {
        path: "verify-email",
        name: "send-email",
        component: SendEmailPage,
        meta: {
          hideAccountLink: true,
          showLogo: true,
          hideButton: true,
          hideDropdown: true,
        },
      },
      {
        path: "reset-password",
        name: "set-new-password",
        component: SetNewPasswordPage,
        meta: {
          hideAccountLink: true,
          showLogo: true,
          hideButton: true,
          hideDropdown: true,
        },
      },
      {
        path: "/",
        redirect: "/login",
      },
    ],
  },
  {
    path: "/operator-quotes",
    name: "operator-quotes",
    component: OperatorQuotePage,
    meta: {
      hideAccountLink: true,
      showLogo: false,
      hideButton: false,
      hideDropdown: true,
    },
  },
  {
    path: "/home",
    name: "home",
    component: HomePage,
    meta: {
      hideAccountLink: false,
      showLogo: true,
      hideButton: false,
      requiresCeo: true,
    },
    children: [
      {
        path: "account",
        name: "account",
        component: AccountPage,
        meta: {
          hideAccountLink: false,
          showLogo: false,
          hideButton: false,
        },
      },
      {
        path: "stock",
        name: "stock",
        component: StockPage,
        meta: {
          hideAccountLink: false,
          showLogo: false,
          hideButton: false,
        },
        children: [
          {
            path: "add-item",
            name: "add-item",
            component: CreateItemPage,
            meta: {
              hideAccountLink: false,
              showLogo: false,
              hideButton: false,
            },
          },
          {
            path: "edit-item/:itemId",
            name: "edit-item",
            component: EditItemPage,
            props: true,
            meta: {
              hideAccountLink: false,
              showLogo: false,
              hideButton: false,
            },
          },
        ],
      },
      {
        path: "clients",
        name: "customers",
        component: ClientPage,
        meta: {
          hideAccountLink: false,
          showLogo: false,
          hideButton: false,
        },
        children: [
          {
            path: "add-client",
            name: "add-client",
            component: CreateClientPage,
            meta: {
              hideAccountLink: false,
              showLogo: false,
              hideButton: false,
            },
          },
          {
            path: "edit-client/:clientId",
            name: "edit-client",
            component: EditClientPage,
            props: true,
            meta: {
              hideAccountLink: false,
              showLogo: false,
              hideButton: false,
            },
          },
        ],
      },
      {
        path: "quotes",
        name: "quotes",
        component: QuotePage,
        meta: {
          hideAccountLink: false,
          showLogo: false,
          hideButton: false,
        },
        children: [
          {
            path: "add-quote",
            name: "add-quote",
            component: CreateQuotePage,
            meta: {
              hideAccountLink: false,
              showLogo: false,
              hideButton: false,
            },
          },
          {
            path: "edit-quote/:quoteId",
            name: "edit-quote",
            component: EditQuotePage,
            props: true,
            meta: {
              hideAccountLink: false,
              showLogo: false,
              hideButton: false,
            },
          },
        ],
      },
      {
        path: "operators",
        name: "operators",
        component: OperatorPage,
        meta: {
          hideAccountLink: false,
          showLogo: false,
          hideButton: false,
        },
        children: [
          {
            path: "add-operator",
            name: "add-operator",
            component: CreateOperatorPage,
            meta: {
              hideAccountLink: false,
              showLogo: false,
              hideButton: false,
            },
          },
          {
            path: "edit-operator/:operatorId",
            name: "edit-operator",
            component: EditOperatorPage,
            props: true,
            meta: {
              hideAccountLink: false,
              showLogo: false,
              hideButton: false,
            },
          },
        ],
      },
    ],
  },
];
const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
});

// Global route guard to check the operatore role
globalBeforeEachGuard(router);

export default router;
//# sourceMappingURL=index.js.map
